<template>
  <div class="money">
    <el-form-item
      :label-width="itemRender.width"
      :label="itemRender.label"
      :required="itemRender.required ? true : false"
    >
      <el-input
        disabled
        v-model="itemRender.value"
        :placeholder="itemRender.placeholder || '请输入'"
      ></el-input>
    </el-form-item>
    <div class="div" v-if="itemRender.numberType == 1">大写</div>
    <div class="div" v-if="itemRender.numberType == 1">
      {{ itemRender.value ? changeToChinese(itemRender.value) : "" }}
    </div>
    <!-- <el-form-item label="大写">
   
      </el-form-item> -->
  </div>
</template>

<script>
export default {
  props: {
    itemRender: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    // 将数字转换为大写金额
    changeToChinese(Num) {
      //判断如果传递进来的不是字符的话转换为字符
      if (typeof Num == "number") {
        Num = new String(Num);
      }
      Num = Num.replace(/,/g, ""); //替换tomoney()中的“,”
      Num = Num.replace(/ /g, ""); //替换tomoney()中的空格
      Num = Num.replace(/￥/g, ""); //替换掉可能出现的￥字符
      if (isNaN(Num)) {
        //验证输入的字符是否为数字
        //alert("请检查小写金额是否正确");
        return "";
      }
      //字符处理完毕后开始转换，采用前后两部分分别转换
      var part = String(Num).split(".");
      var newchar = "";
      //小数点前进行转化
      for (var i = part[0].length - 1; i >= 0; i--) {
        if (part[0].length > 10) {
          return "";
          //若数量超过拾亿单位，提示
        }
        var tmpnewchar = "";
        var perchar = part[0].charAt(i);
        switch (perchar) {
          case "0":
            tmpnewchar = "零" + tmpnewchar;
            break;
          case "1":
            tmpnewchar = "壹" + tmpnewchar;
            break;
          case "2":
            tmpnewchar = "贰" + tmpnewchar;
            break;
          case "3":
            tmpnewchar = "叁" + tmpnewchar;
            break;
          case "4":
            tmpnewchar = "肆" + tmpnewchar;
            break;
          case "5":
            tmpnewchar = "伍" + tmpnewchar;
            break;
          case "6":
            tmpnewchar = "陆" + tmpnewchar;
            break;
          case "7":
            tmpnewchar = "柒" + tmpnewchar;
            break;
          case "8":
            tmpnewchar = "捌" + tmpnewchar;
            break;
          case "9":
            tmpnewchar = "玖" + tmpnewchar;
            break;
        }
        switch (part[0].length - i - 1) {
          case 0:
            tmpnewchar = tmpnewchar + "元";
            break;
          case 1:
            if (perchar != 0) tmpnewchar = tmpnewchar + "拾";
            break;
          case 2:
            if (perchar != 0) tmpnewchar = tmpnewchar + "佰";
            break;
          case 3:
            if (perchar != 0) tmpnewchar = tmpnewchar + "仟";
            break;
          case 4:
            tmpnewchar = tmpnewchar + "万";
            break;
          case 5:
            if (perchar != 0) tmpnewchar = tmpnewchar + "拾";
            break;
          case 6:
            if (perchar != 0) tmpnewchar = tmpnewchar + "佰";
            break;
          case 7:
            if (perchar != 0) tmpnewchar = tmpnewchar + "仟";
            break;
          case 8:
            tmpnewchar = tmpnewchar + "亿";
            break;
          case 9:
            tmpnewchar = tmpnewchar + "拾";
            break;
        }
        var newchar = tmpnewchar + newchar;
      }
      //小数点之后进行转化
      if (Num.indexOf(".") != -1) {
        if (part[1].length > 2) {
          // alert("小数点之后只能保留两位,系统将自动截断");
          part[1] = part[1].substr(0, 2);
        }
        for (i = 0; i < part[1].length; i++) {
          tmpnewchar = "";
          perchar = part[1].charAt(i);
          switch (perchar) {
            case "0":
              tmpnewchar = "零" + tmpnewchar;
              break;
            case "1":
              tmpnewchar = "壹" + tmpnewchar;
              break;
            case "2":
              tmpnewchar = "贰" + tmpnewchar;
              break;
            case "3":
              tmpnewchar = "叁" + tmpnewchar;
              break;
            case "4":
              tmpnewchar = "肆" + tmpnewchar;
              break;
            case "5":
              tmpnewchar = "伍" + tmpnewchar;
              break;
            case "6":
              tmpnewchar = "陆" + tmpnewchar;
              break;
            case "7":
              tmpnewchar = "柒" + tmpnewchar;
              break;
            case "8":
              tmpnewchar = "捌" + tmpnewchar;
              break;
            case "9":
              tmpnewchar = "玖" + tmpnewchar;
              break;
          }
          if (i == 0) tmpnewchar = tmpnewchar + "角";
          if (i == 1) tmpnewchar = tmpnewchar + "分";
          newchar = newchar + tmpnewchar;
        }
      }
      //替换所有无用汉字
      while (newchar.search("零零") != -1)
        newchar = newchar.replace("零零", "零");
      newchar = newchar.replace("零亿", "亿");
      newchar = newchar.replace("亿万", "亿");
      newchar = newchar.replace("零万", "万");
      newchar = newchar.replace("零元", "元");
      newchar = newchar.replace("零角", "");
      newchar = newchar.replace("零分", "");
      if (newchar.charAt(newchar.length - 1) == "元") {
        newchar = newchar;
        // newchar = newchar + "整";
      }
      return newchar;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .el-radio {
    margin-bottom: 12px;
  }
}
.vacate {
  .vacate-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding: 0 0 8px;
    border-bottom: 1px solid #dfe2e8;
    ::v-deep .el-input__inner {
      border: 0;
    }
    span {
      width: 100px;
    }
  }
}
.el-form-item {
  position: relative;
  .phone {
    position: absolute;
    right: 10px;
    top: 0px;
  }
  .phoneNumber {
    display: flex;
    align-items: center;
    border: 1px solid #dfe2e8;
    padding: 0 8px;
    ::v-deep .el-input__inner {
      border: 0;
    }
    span {
      padding-right: 8px;
      border-right: 1px solid #dfe2e8;
    }
  }
  .enclosure {
    display: flex;
    align-items: center;
    color: #999999;
    i {
      color: #5794f6;
      font-size: 18px;
      font-weight: bold;
      margin-right: 8px;
    }
  }
}
.money {
  .div {
    margin-top: 12px;
  }
}
</style>
